/**
 * Created by cc 19-10-28
 * 添加抖音账号模块
 */
'use strict';
angular.module('productManageMentTrillAccountAddModule', []).controller('ProductManageMentTrillAccountAddCtrl', ['$scope', '$modalInstance', '$validation', 'trsHttpService',
    function($scope, $modalInstance, $validation, trsHttpService) {
        initStatus();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.data = {
                currUser: {
                    sinaLoginUserName: '',
                    is_original: '0'
                }
            };
        }

        /**
         * [checkProperty description] 是否检查稿件属性
         * @return {[type]} [description]
         */
        $scope.checkProperty = function() {
            $scope.data.currUser.is_original = $scope.data.currUser.is_original == '0' ? '1' : '0';
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var params = {
                serviceid: 'mlf_douyinconfig',
                methodName: 'saveDouYinAccount',
                douYinAccountName: $scope.data.currUser.sinaLoginUserName,
                // scope: 'user_info,video.create,aweme.share'
                // sinaUserLoginPwd: $scope.data.currUser.sinaUserLoginPwd,
                is_original: $scope.data.currUser.is_original,
                // ISPAICHONG: $scope.data.currUser.ISPAICHONG,
                // CKMSIMDAYRANGE: $scope.data.currUser.CKMSIMDAYRANGE
            };
            $scope.accountForm.$pending = {};
            $validation.validate($scope.accountForm).success(function() {
                LazyLoad.js(['./lib/js-base64/base64.js'], function() {
                    $modalInstance.close({result: true});
                    // params.sinaUserLoginPwd = Base64.encode(angular.copy($scope.data.currUser.sinaUserLoginPwd));
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', params, 'post', true).then(function(data) {
                        window.open(JSON.parse(data));
                    }, function(data) {
                        $modalInstance.close({data: data});
                    });
                });
            });
        };
    }
]);
